<template>
  <div class="questionnaire-content">
    <div class="questionnaire-content__block">
      <p class="questionnaire__title -min-margin-">
        Спасибо, теперь мы знакомы ближе!
      </p>
      <p class="questionnaire__description">
        Узнай об участниках, с которыми будешь проходить курс, 
        получай полезные материалы и будь в курсе событий с нашим Telegram ботом
      </p>
    </div>
    <div class="questionnaire-content__block">
      <p class="questionnaire-content__title">
        Регистрируйся в чат-боте курса!
      </p>
    </div>
    <div class="questionnaire-content__block">
      <UiInput
        v-model.trim="telegram"
        class="-bg-neutral- questionnaire-content__input -l-"
        title="Введи свой Telegram"
        placeholder="username"
        before="@"
        :popup="validPopup(!$v.telegram.required, 'Обязательное поле') || 
          validPopup(!$v.telegram.isTelegram, 'Недопустимый символ') || 
          validPopup(!$v.telegram.minLength, 'Минимальная длинна - 5 символов')"
      />
    </div>
    <div class="questionnaire-content__block -margin-l-">
      <p
        class="questionnaire-content__link"
        @click="setStep('TelegramHelper')"
      >
        Как узнать свой @username
      </p>
    </div>
    <div class="questionnaire-content__block -margin-s-">
      <UiButton @click="send">
        Подтвердить
      </UiButton>
    </div>
    <div class="questionnaire-content__block">
      <UiButton
        class="-gray-"
        @click="setStep('NoTelegram')"
      >
        У меня нет Telegram
      </UiButton>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { required, minLength } from 'vuelidate/lib/validators';

export default {
  data: () => ({
    telegram: ''
  }),
  computed: {
    ...mapState('questionnaire', {
      history: s => s.data.history,
      telegramName: s => s.data.telegramName
    })
  },
  mounted() {
    this.telegram = this.telegramName;
  },
  methods: {
    comeBack() {
      this.$router.push('/questionnaire/toggle-course');
    },
    async send() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      const res = await this.$store.dispatch(
        'questionnaire/sendTelegramUsername',
        { username: this.telegram }
      );
      if (res.status === 'success') {
        this.$store.dispatch('questionnaire/setData', {
          path: 'telegramName',
          value: this.telegram
        });
        this.setStep('SendCode');
      }
    },
    validPopup(isErr, text) {
      if (!this.$v.$dirty) {
        return;
      }

      if (isErr) {
        return {
          msg: text,
          error: true
        };
      }
    },
    setStep(step) {
      this.$emit('setStep', step);
    }
  },
  validations: {
    telegram: {
      isTelegram(value) {
        return !/[^A-Za-z_\d]/.test(value);
      },
      required,
      minLength: minLength(5)
    }
  }
};
</script>
